module.exports = __webpack_public_path__ + "img/icon-past-product.1cbbb01a.svg";